import React, { useEffect, useState } from "react";

import axios from "axios";

import {
  User,
  Phone,
  Mail,
  MapPin,
  Bike,
  Calendar,
  Eye,
  X,
  IndianRupee,
  CheckCircle,
  AlertCircle,
} from "lucide-react";

import "../css/Bookings.css";

const Bookings = () => {

  const [bookings, setBookings] = useState([]);


const [bulkBookings, setBulkBookings] =
  useState([]);

const [activeTab, setActiveTab] =
  useState("bookings");

  const [loading, setLoading] = useState(true);

  const [selectedBooking, setSelectedBooking] =
    useState(null);

  useEffect(() => {
    fetchBookings();
      fetchBulkBookings();

  }, []);

  /**
   * FETCH BOOKINGS
   */
  const fetchBookings = async () => {

    try {

      setLoading(true);

      const res = await axios.get(
        "/api/admin/bookings"
      );

      if (res.data.success) {

        setBookings(res.data.data || []);
      }

    } catch (error) {

      console.log(
        "FETCH BOOKINGS ERROR:",
        error
      );

    } finally {

      setLoading(false);
    }
  };

  const fetchBulkBookings = async () => {

  try {

    const res = await axios.get(
      "/api/bulk-bookings"
    );

    if (res.data.success) {

      setBulkBookings(res.data.data || []);
    }

  } catch (error) {

    console.log(
      "FETCH BULK BOOKINGS ERROR:",
      error
    );
  }
};

  /**
   * CLOSE MODAL
   */
  const closeModal = () => {
    setSelectedBooking(null);
  };

  return (
    <div className="bookings-page">

      {/* HEADER */}
      <div className="bookings-header">

        <div>

          <h1>
            Bookings
          </h1>

          <p>
            Manage all customer vehicle
            bookings
          </p>

        </div>

        <div className="booking-count">

          {bookings.length} Bookings

        </div>
      </div>

      <div className="bookings-tabs">

  <button
    className={`booking-tab-btn ${
      activeTab === "bookings"
        ? "active"
        : ""
    }`}
    onClick={() =>
      setActiveTab("bookings")
    }
  >
    Book Now Forms
  </button>

  <button
    className={`booking-tab-btn ${
      activeTab === "bulk"
        ? "active"
        : ""
    }`}
    onClick={() =>
      setActiveTab("bulk")
    }
  >
    Bulk Booking Forms
  </button>

</div>

      {/* TABLE */}
      <div className="bookings-table-wrapper">

        <table className="bookings-table">

          <thead>

            <tr>

              <th>
                Booking ID
              </th>

              <th>
                Customer
              </th>

              <th>
                Vehicle
              </th>

                {activeTab === "bulk" && (
      <th>City</th>
    )}

             {/* <th>
                City
              </th>
               */}

              {/* <th>
                Payment
              </th> */}

              <th>
                Date
              </th>

              <th>
                Status
              </th>

              <th>
                Action
              </th>

            </tr>

          </thead>

          <tbody>

  {/* BOOK NOW */}
  {activeTab === "bookings" && (

    loading ? (

      <tr>
        <td colSpan="8">
          Loading bookings...
        </td>
      </tr>

    ) : bookings.length === 0 ? (

      <tr>
        <td colSpan="8">
          No bookings found
        </td>
      </tr>

    ) : (

      bookings.map((item, index) => {

        const customer =
          item.customer || {};

        const transaction =
          item.transaction || {};

        return (

          <tr key={index}>

            <td className="booking-id">
              {item.booking_id}
            </td>

            <td>
              <div className="customer-name">
                {customer.full_name || "-"}
              </div>

              <div className="customer-phone">
                {customer.phone || "-"}
              </div>
            </td>

            <td>
              <div className="vehicle-name">
                {item.modelname || "-"}
              </div>
            </td>

           

            <td>
              {transaction.created_at
                ? new Date(
                    transaction.created_at
                  ).toLocaleDateString()
                : "-"}
            </td>

            <td>
              <div 
              className={`booking-status ${item.status?.toLowerCase() || ""}`}
              >
                {item.status || ""}
              </div>
            </td>

            <td>

              <button
                className="view-booking-btn"
                onClick={() =>
                  setSelectedBooking(item)
                }
              >
                <Eye size={16} />
                View
              </button>

            </td>

          </tr>
        );
      })
    )
  )}

  {/* BULK BOOKINGS */}
  {activeTab === "bulk" && (

    bulkBookings.length === 0 ? (

      <tr>
        <td colSpan="8">
          No bulk bookings found
        </td>
      </tr>

    ) : (

      bulkBookings.map((item) => (

        <tr key={item.id}>

          <td className="booking-id">
            BULK-{item.id}
          </td>

          <td>

            <div className="customer-name">
              {item.fullName}
            </div>

            <div className="customer-phone">
              {item.phone}
            </div>

          </td>

          <td>
            <div className="vehicle-name">
              Bulk Booking
            </div>
          </td>
 
         <td className="customer-phone">
          {item.city}
         </td>
          

         

          <td>

            {item.submittedDate
              ? new Date(
                  item.submittedDate
                ).toLocaleDateString()
              : "-"}

          </td>

          <td>
            -
          </td>

          <td>

            <button
              className="view-booking-btn"
              onClick={() =>
                setSelectedBooking({
                  type: "bulk",
                  ...item,
                })
              }
            >
              <Eye size={16} />
              View
            </button>

          </td>

        </tr>
      ))
    )
  )}

</tbody>
        </table>
      </div>

      {/* MODAL */}
      {selectedBooking && (

        <div className="booking-modal-overlay">

          <div className="booking-modal">

            {/* MODAL HEADER */}
            <div className="booking-modal-header">

              <div>

              <h2>

  {selectedBooking.type === "bulk"
    ? "Bulk Booking Details"
    : "Booking Details"}

</h2>

                <p>
                  {
                    selectedBooking.booking_id
                  }
                </p>

              </div>

              <button
                className="close-modal-btn"
                onClick={closeModal}
              >
                <X size={22} />
              </button>

            </div>

          <div className="booking-modal-body">

  {/* ========================= */}
  {/* BULK BOOKING MODAL */}
  {/* ========================= */}

  {selectedBooking.type === "bulk" ? (

    <>
      {/* CUSTOMER */}
      <div className="booking-section">

        <h3>
          Customer Information
        </h3>

        <div className="booking-details-grid">

          {/* NAME */}
          <div className="detail-box">

            <User size={18} />

            <div>

              <span>
                Full Name
              </span>

              <p>
                {selectedBooking.fullName || "-"}
              </p>

            </div>
          </div>

          {/* PHONE */}
          <div className="detail-box">

            <Phone size={18} />

            <div>

              <span>
                Phone
              </span>

              <p>
                {selectedBooking.phone || "-"}
              </p>

            </div>
          </div>

          {/* EMAIL */}
          <div className="detail-box">

            <Mail size={18} />

            <div>

              <span>
                Email
              </span>

              <p>
                {selectedBooking.email || "-"}
              </p>

            </div>
          </div>

          <div className="detail-box">

  <MapPin size={18} />

  <div>

    <span>
      City
    </span>

    <p>
      {selectedBooking.city || "-"}
    </p>

  </div>
</div>

          {/* DATE */}
          <div className="detail-box">

            <Calendar size={18} />

            <div>

              <span>
                Submitted Date
              </span>

              <p>

                {selectedBooking.submittedDate
                  ? new Date(
                      selectedBooking.submittedDate
                    ).toLocaleString()
                  : "-"}

              </p>

            </div>
          </div>

        </div>
      </div>
    </>

  ) : (

    <>
      {/* ========================= */}
      {/* NORMAL BOOKING MODAL */}
      {/* ========================= */}

      {/* CUSTOMER */}
      <div className="booking-section">

        <h3>
          Customer Information
        </h3>

        <div className="booking-details-grid">

          {/* NAME */}
          <div className="detail-box">

            <User size={18} />

            <div>

              <span>
                Name
              </span>

              <p>
                {
                  selectedBooking
                    .customer
                    ?.full_name
                }
              </p>

            </div>
          </div>

          {/* PHONE */}
          <div className="detail-box">

            <Phone size={18} />

            <div>

              <span>
                Phone
              </span>

              <p>
                {
                  selectedBooking
                    .customer
                    ?.phone
                }
              </p>

            </div>
          </div>

          {/* EMAIL */}
          <div className="detail-box">

            <Mail size={18} />

            <div>

              <span>
                Email
              </span>

              <p>
                {
                  selectedBooking
                    .customer
                    ?.email
                }
              </p>

            </div>
          </div>

          {/* CITY */}
          <div className="detail-box">

            <MapPin size={18} />

            <div>

              <span>
                City
              </span>

              <p>
                {
                  selectedBooking
                    .customer
                    ?.city
                }
              </p>

            </div>
          </div>

        </div>
      </div>

      {/* VEHICLE */}
      <div className="booking-section">

        <h3>
          Vehicle Information
        </h3>

        <div className="vehicle-preview-card">

          {/* IMAGE */}
          <div className="vehicle-image-wrapper">

            {selectedBooking.image ? (

              <img
                src={selectedBooking.image}
                alt={selectedBooking.modelname}
                className="vehicle-image"
              />

            ) : (

              <div className="vehicle-image-placeholder">
                No Image
              </div>

            )}
          </div>

          {/* DETAILS */}
          <div className="vehicle-info-content">

            <div className="booking-details-grid">

              {/* MODEL */}
              <div className="detail-box">

                <Bike size={18} />

                <div>

                  <span>
                    Vehicle
                  </span>

                  <p>
                    {
                      selectedBooking.modelname
                    }
                  </p>

                </div>
              </div>

              {/* PRICE */}
              <div className="detail-box">

                <IndianRupee size={18} />

                <div>

                  <span>
                    Amount
                  </span>

                  <p>
                    ₹
                    {
                      selectedBooking.price
                    }
                  </p>

                </div>
              </div>

              {/* COLOR */}
              <div className="detail-box">

                <div
                  className="color-preview"
                  style={{
                    background:
                      selectedBooking.color ||
                      "#ccc",
                  }}
                />

                <div>

                  <span>
                    Color
                  </span>

                  <p>
                    {
                      selectedBooking.color ||
                      "-"
                    }
                  </p>

                </div>
              </div>

              {/* DATE */}
              <div className="detail-box">

                <Calendar size={18} />

                <div>

                  <span>
                    Booking Date
                  </span>

                  <p>

                    {
                      selectedBooking
                        .transaction
                        ?.created_at
                        ? new Date(
                            selectedBooking
                              .transaction
                              ?.created_at
                          ).toLocaleString()
                        : "-"
                    }

                  </p>

                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      {/* MARKETING */}
      <div className="booking-section">

        <h3>
          Marketing Information
        </h3>

        <div className="booking-details-grid">

          {/* UTM SOURCE */}
          <div className="detail-box">

            <div>

              <span>
                UTM Source
              </span>

              <p>
                {
                  selectedBooking
                    .utm_source || "-"
                }
              </p>

            </div>
          </div>

          {/* UTM MEDIUM */}
          <div className="detail-box">

            <div>

              <span>
                UTM Medium
              </span>

              <p>
                {
                  selectedBooking
                    .utm_medium || "-"
                }
              </p>

            </div>
          </div>

          {/* UTM CAMPAIGN */}
          <div className="detail-box">

            <div>

              <span>
                UTM Campaign
              </span>

              <p>
                {
                  selectedBooking
                    .utm_campaign || "-"
                }
              </p>

            </div>
          </div>

        </div>
      </div>
    </>
  )}

</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Bookings;

